import { AuditPersonType } from '@interfaces/audit-person-type';
import AppContext from '@services/Context';
import { Col, Row } from 'antd';
import * as React from 'react';
import { TicketStatus } from 'src/interfaces/ticket-status';
import styled from 'styled-components';

import I18n from '../../../../i18n';
import WorkflowItemInfoComponent from './WorkflowItemInfoComponent';
import WorkflowStatusComponent from './WorkflowStatusComponent';

interface IProp {
    auditorName: string
    auditedName: string
    auditPersonType?: AuditPersonType
    status: TicketStatus;
    statusLabel?: string
    date: string;
    auditWithTitle?:string;
}

class WorkflowItemComponent extends React.Component<IProp, {}> {

    render(): JSX.Element {
        return (
            <AppContext.Consumer>
                {({ locale, theme }) => (
                    <GoEpikWorkflowItem>
                        <Row className="goepik-side-padding">
                            <Col sm={24} md={24} xl={24}>
                                <Row>
                                    <Col sm={24} md={24} xl={24}>
                                        <h3 className="goepik-workflow-title">{ 
                                            (!!this.props.auditWithTitle ? this.props.auditWithTitle : I18n.l('history.audits.titles.auditWith') )
                                            + " " + I18n.l('common.with') + " " +
                                         (this.props.auditPersonType == AuditPersonType.AUDITOR ? this.props.auditedName :  this.props.auditorName)}</h3>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={24} md={24} xl={24}>
                                        <WorkflowStatusComponent
                                            status={this.props.status}
                                            statusLabel={this.props.statusLabel}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={24} md={24} xl={24}>
                                        <WorkflowItemInfoComponent
                                            title={this.props.date}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </GoEpikWorkflowItem>
                )}
            </AppContext.Consumer>
        );
    }
};

const GoEpikWorkflowItem = styled.div`  
    .goepik-side-padding{
        padding-left: 24px!important;
        padding-right: 24px!important;
        padding: 24px;
    }
    .goepik-workflow-title{
        font-weight: 900;
    }
`;

export default WorkflowItemComponent;
